import axios from "axios";

const API = axios.create({
  // baseURL: "http://localhost:3000/api/v1",
  baseURL:
    "https://meetinghubadmin.insync-ai-suite.com/muscatinspection/api/v1",
});

// Attach token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

/* ================= AUTH ================= */
export const loginAPI = (data) => API.post("/auth/login", data);

/* ================= COMPANY (TENANT) ================= */
export const companyDashboardAPI = () => API.get("/company/dashboard");

// Users - Complete CRUD
export const getUsersAPI = () => API.get("/company/users");
export const getUserAPI = (userId) => API.get(`/company/users/${userId}`);
export const createUserAPI = (data) => API.post("/company/users", data);
export const updateUserAPI = (userId, data) =>
  API.patch(`/company/users/${userId}`, data);
export const deleteUserAPI = (userId) => API.delete(`/company/users/${userId}`);

// Roles - Complete CRUD
export const getRolesAPI = () => API.get("/company/roles");
export const getRoleAPI = (roleKey) => API.get(`/company/roles/${roleKey}`);
export const createRoleAPI = (data) => API.post("/company/roles", data);
export const updateRoleAPI = (roleKey, data) =>
  API.patch(`/company/roles/${roleKey}`, data);
export const deleteRoleAPI = (roleKey) =>
  API.delete(`/company/roles/${roleKey}`);

// Departments - Complete CRUD
export const getDepartmentsAPI = () => API.get("/company/departments");
export const getDepartmentAPI = (departmentId) =>
  API.get(`/company/departments/${departmentId}`);
export const createDepartmentAPI = (data) =>
  API.post("/company/departments", data);
export const updateDepartmentAPI = (departmentId, data) =>
  API.patch(`/company/departments/${departmentId}`, data);
export const deleteDepartmentAPI = (departmentId) =>
  API.delete(`/company/departments/${departmentId}`);

export const getIntegrationsAPI = () => API.get("/company/integrations");
export const connectIntegrationAPI = (data) =>
  API.post("/company/integrations", data);

export const getChannelsAPI = () => API.get("/company/channels");
export const getSchedulingRulesAPI = () => API.get("/company/scheduling-rules");

export const getAttendeeDirectoryAPI = () =>
  API.get("/company/attendee-directory");

export const getTemplatesAPI = () => API.get("/company/templates");
export const createTemplateAPI = (data) => API.post("/company/templates", data);

export const getNotificationsAPI = () => API.get("/company/notifications");

export const getReportsAPI = () => API.get("/company/reports");

export const getAuditLogsAPI = () => API.get("/company/audit-logs");

export const getCompanySettingsAPI = () => API.get("/company/company-settings");

/* ================= PLATFORM ================= */
export const platformDashboardAPI = () => API.get("/platform/dashboard");

export const getTenantsAPI = () => API.get("/platform/tenants");
export const createTenantAPI = (data) => API.post("/platform/tenants", data);
export const updateTenantAPI = (tenantId, data) =>
  API.patch(`/platform/tenants/${tenantId}`, data);

export const getSubscriptionsAPI = () => API.get("/platform/subscriptions");

export const getUsageQuotasAPI = () => API.get("/platform/usage-quotas");

export const getIntegrationsMonitorAPI = () =>
  API.get("/platform/integrations-monitor");

export const getJobsFailuresAPI = () => API.get("/platform/jobs-failures");

export const getGlobalTemplatesAPI = () =>
  API.get("/platform/global-templates");

export const getGlobalAIPoliciesAPI = () =>
  API.get("/platform/global-ai-policies");

export const getBillingAPI = () => API.get("/platform/billing");

export const getSupportToolsAPI = () => API.get("/platform/support-tools");

export const getSystemSettingsAPI = () => API.get("/platform/system-settings");

/* ================= MEETINGS ================= */
export const getMeetingsAPI = () => API.get("/meetings");
export const getMeetingByIdAPI = (id) => API.get(`/meetings/${id}`);
export const createMeetingAPI = (data) => API.post("/meetings", data);
export const updateMeetingAPI = (id, data) =>
  API.patch(`/meetings/${id}`, data);
export const cancelMeetingAPI = (id) => API.post(`/meetings/${id}/cancel`);
export const checkAvailabilityAPI = (data) =>
  API.post("/meetings/availability/check", data);

/* ================= TRANSCRIPTS ================= */
export const getTranscriptsAPI = () => API.get("/transcripts");
export const createTranscriptAPI = (data) => API.post("/transcripts", data);

export const getMomAPI = () => API.get("/transcripts/mom");
export const createMomAPI = (data) => API.post("/transcripts/mom", data);

/* ================= WHATSAPP ================= */
export const getBotMenuAPI = () => API.get("/whatsapp/menu");
export const getBotTemplatesAPI = () => API.get("/whatsapp/templates");
export const createBotSessionAPI = (data) =>
  API.post("/whatsapp/sessions", data);

/* ================= WEBHOOKS ================= */
export const whatsappWebhookAPI = (data) =>
  API.post("/webhooks/whatsapp", data);

export const teamsWebhookAPI = (data) => API.post("/webhooks/teams", data);

export const googleMeetWebhookAPI = (data) =>
  API.post("/webhooks/google-meet", data);

/* ================= JOB QUEUE ================= */
export const getJobQueueAPI = async (filters) => {
  const params = new URLSearchParams();
  if (filters?.queue) params.append("queue", filters.queue);
  if (filters?.status) params.append("status", filters.status);
  if (filters?.tenantSearch)
    params.append("tenantSearch", filters.tenantSearch);
  if (filters?.dateFrom) params.append("dateFrom", filters.dateFrom);
  if (filters?.dateTo) params.append("dateTo", filters.dateTo);
  if (filters?.page) params.append("page", filters.page);
  if (filters?.limit) params.append("limit", filters.limit);

  const queryString = params.toString();
  const response = await API.get(
    `/admin/queue/jobs${queryString ? `?${queryString}` : ""}`,
  );
  return response;
};

export const pauseQueueAPI = (queueName) =>
  API.post(`/admin/queue/${queueName}/pause`);

export const resumeQueueAPI = (queueName) =>
  API.post(`/admin/queue/${queueName}/resume`);

export const retryJobAPI = (jobId) =>
  API.post(`/admin/queue/jobs/${jobId}/retry`);

export const retryAllRetryableAPI = () => API.post("/admin/queue/retry-all");

export const getJobDetailsAPI = (jobId) =>
  API.get(`/admin/queue/jobs/${jobId}`);

export const getQueueStatsAPI = () => API.get("/admin/queue/stats");

export const cleanupJobsAPI = () => API.delete("/admin/queue/jobs/cleanup");

export default API;
